// src/documentTypes.ts

export interface DocumentTypeOption {
  label: string;
  value: string;
}

export interface DocumentTypeGroup {
  groupName: string;
  options: DocumentTypeOption[];
}

/**
 * Canonical list of supported document types.
 * Values are intentionally verbose so they remain
 * human-readable in Firestore, exports, and audit logs.
 */
export const DOCUMENT_TYPE_GROUPS: DocumentTypeGroup[] = [
  {
    groupName: "Income Documents",
    options: [
      { label: "W-2 Wage Statement", value: "W-2 Wage Statement" },
      { label: "1099-NEC Nonemployee Compensation", value: "1099-NEC Nonemployee Compensation" },
      { label: "1099-MISC Miscellaneous Income", value: "1099-MISC Miscellaneous Income" },
      { label: "1099-K Payment Processor Statement", value: "1099-K Payment Processor Statement" },
      { label: "1099-INT Interest Income", value: "1099-INT Interest Income" },
      { label: "1099-DIV Dividend Income", value: "1099-DIV Dividend Income" },
      { label: "1099-B Brokerage Transactions", value: "1099-B Brokerage Transactions" },
      { label: "Schedule K-1 Partnership or S Corporation", value: "Schedule K-1 Partnership or S Corporation" },
    ],
  },

  {
    groupName: "Business Documents",
    options: [
      { label: "Profit and Loss Statement", value: "Profit and Loss Statement" },
      { label: "Business Expense Receipts", value: "Business Expense Receipts" },
      { label: "Mileage Log", value: "Mileage Log" },
      { label: "Asset Purchases or Depreciation Schedule", value: "Asset Purchases or Depreciation Schedule" },
      { label: "Business Bank Statements", value: "Business Bank Statements" },
      { label: "Business Credit Card Statements", value: "Business Credit Card Statements" },
    ],
  },

  {
    groupName: "Personal Information",
    options: [
      { label: "Government Issued Photo ID", value: "Government Issued Photo ID" },
      { label: "Social Security Card", value: "Social Security Card" },
      { label: "Dependent Information", value: "Dependent Information" },
      { label: "Prior Year Tax Return", value: "Prior Year Tax Return" },
    ],
  },

  {
    groupName: "Tax Forms and Notices",
    options: [
      { label: "IRS Letter or Notice", value: "IRS Letter or Notice" },
      { label: "State Tax Notice", value: "State Tax Notice" },
      { label: "Estimated Tax Payments Proof", value: "Estimated Tax Payments Proof" },
      { label: "Extension Filing Confirmation", value: "Extension Filing Confirmation" },
    ],
  },

  {
    groupName: "Credits and Deductions",
    options: [
      { label: "Childcare Expenses", value: "Childcare Expenses" },
      { label: "Education Expenses Form 1098-T", value: "Education Expenses Form 1098-T" },
      { label: "Mortgage Interest Form 1098", value: "Mortgage Interest Form 1098" },
      { label: "Property Tax Statement", value: "Property Tax Statement" },
      { label: "Charitable Donations", value: "Charitable Donations" },
    ],
  },

  {
    groupName: "Other",
    options: [
      { label: "Health Insurance Form 1095-A", value: "Health Insurance Form 1095-A" },
      { label: "Retirement Contributions", value: "Retirement Contributions" },
      { label: "Foreign Income or Assets", value: "Foreign Income or Assets" },
      { label: "Other Tax Documents", value: "Other Tax Documents" },
      { label: "Not Sure – Upload Anyway", value: "Not Sure – Upload Anyway" },
    ],
  },
];

/**
 * Flat list helper (useful for selects, validation, or Firestore rules)
 */
export const ALL_DOCUMENT_TYPE_VALUES = DOCUMENT_TYPE_GROUPS.flatMap(group =>
  group.options.map(opt => opt.value)
);
